<template>
  <div>
    <Bandwidth
      :plan="getPlan()"
      :plan-status="status"
      :site="site"
      :site-status="status"
      class="mb-4"
    />
    <PhpFpm :plan="getPlan()" :plan-status="status" :site="site" :site-status="status" />
  </div>
</template>

<script>
import Bandwidth from "@/components/smart/cards/Bandwidth";
import { computed } from "@vue/composition-api";
import PhpFpm from "@/components/smart/cards/PhpFpm";
import store from "@/store";

export default {
  name: "SharedHostSafeHarborStagingEnvironmentPerformancePage",
  components: {
    Bandwidth,
    PhpFpm,
  },
  setup() {
    const site = computed(() => store.getters["devSites/getItem"]);
    const status = computed(() => store.getters["devSites/getItemStatus"]);

    const getPlan = () => site.value.plan;

    return {
      getPlan,
      site,
      status,
    };
  },
};
</script>
